import CommonService from '@/services/CommonService';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import dayjs from 'dayjs';
import {
  SET_MESSAGE_MODAL,
} from '../mutation-types';
import PrinterService from '../../services/PrinterService';
import bill from './bill';
import { isArray } from 'vue-mq/src/utils';
// state
const localState = {
  posPrinter: null,
  config: null,
  usbInterface: null,
  alternate: null,
  outEndpoint: null,
  webUsbQueue: [],
  closeTimeout: null,
  queueRunning: false
};

// getters
const localGetters = {
  fetchConfiguration: (state, getters) => {
    state
      .posPrinter
      .configurations
      .forEach((config) => {
        if (!state.configuration
            && config.interfaces
            && config.interfaces.length > 0
        ) {
          getters.fetchInterface(config);
        }
      });
  },

  fetchInterface: (state, getters) => (config) => {
    config.interfaces.forEach((usbInterface) => {
      if (!state.usbInterface
          && !usbInterface.claimed
          && usbInterface.alternates
          && usbInterface.alternates.length > 0
      ) {
        getters.fetchAlternate(config, usbInterface);
      }
    });
  },

  fetchAlternate: (state, getters) => (config, usbInterface) => {
    usbInterface.alternates.forEach((alternate) => {
      if (!state.alternate
          && alternate.endpoints
          && alternate.endpoints.length > 0
      ) {
        getters.fetchOutEndPoint(config, usbInterface, alternate);
      }
    });
  },

  fetchOutEndPoint: state => (config, usbInterface, alternate) => {
    alternate.endpoints.forEach((endpoint) => {
      if (!state.outEndpoint
          && endpoint.direction
          && endpoint.direction == 'out'
          && endpoint.type
          && endpoint.type == 'bulk'
      ) {
        state.outEndpoint = endpoint;
        state.config = config;
        state.usbInterface = usbInterface;
        state.alternate = alternate;
      }
    });
  },

  clearConfig: (state) => {
    state.outEndpoint = null;
    state.config = null;
    state.usbInterface = null;
    state.alternate = null;
    state.posPrinter = null;
  },

};

// actions
const actions = {
  async print({
    state, rootState, dispatch,
  }, billData) {
    const printerServerAddress = rootState.auth.user.location.printerServerAddress;
    if(!billData || !Array.isArray(billData)) return;
    for(let i = 0; i < billData.length; i++) {
      if (!printerServerAddress || !billData[i].printerAddress) {
        // no printer address, might be cashier using webUSB
        await dispatch('printWebUSB', billData[i].data);
      } else {
        // noprinter happens on kitchen / bar only, for cashier, it will prompt for webUSB
        if(billData[i].printerAddress !== 'noprinter') {
          PrinterService.printer(billData[i], printerServerAddress);
        }
      }
    }
  },

  async printWebUSB({
    state, dispatch, commit,
  }, billData) {
    if (!navigator.usb) return;
    if (!billData) return;
    if (billData.error) {
      commit(SET_MESSAGE_MODAL, { error: billData.error, code: 500 });
      return;
    }

    state.webUsbQueue.push(billData);
    if(!state.queueRunning) {
      state.queueRunning = true;
      if(!state.posPrinter || !state.config) {
        await dispatch('connectDevice');
      }
      await dispatch('transferToDevice');
    }
  },

  async transferToDevice({ state, getters }) {
    console.log(state);
    clearTimeout(state.closeTimeout);
    if (state.posPrinter) {
      if(!state.posPrinter.opened) {
        try {
          await state.posPrinter.open();
          await state.posPrinter.selectConfiguration(state.config.configurationValue);
          await state.posPrinter.claimInterface(state.usbInterface.interfaceNumber);
        } catch(error) {
          console.log(state.posPrinter);
          if (error.message == 'Access denied.') {
            state.posPrinter.close();
          }
          alert(error.message);
          getters.clearConfig;
          console.log('open', error.code);
          console.log(error.message);
        }
      }
      console.log('check if listened', navigator.usb.hasOwnProperty('ondisconnect'));
      navigator.usb.addEventListener('disconnect', (usbEvent) => {
        if (state.posPrinter.vendorId == usbEvent.device.vendorId
            && state.posPrinter.productId == usbEvent.device.productId) {
          alert('The printer has been disconnect. Please Reconnect and click ok. Connection request will be done again after the application has been reloaded.');
          getters.clearConfig;
          window.location.reload();
        }
      });
      try {
        for(let i = 0; i < state.webUsbQueue.length; i++) {
          const data = CommonService.base64DecToArr(state.webUsbQueue[i]);
          await state.posPrinter.transferOut(state.outEndpoint.endpointNumber, data)
        }
        state.webUsbQueue = [];
      } catch(error) {
        alert(error.message);
        console.log('transfer then close', error.code);
        console.log(error.message);
        getters.clearConfig;
      }
      state.queueRunning = false;
      state.closeTimeout = setTimeout(() => {
        if(state.posPrinter && state.posPrinter.opened) {
          try {
            state.posPrinter.close()
          } catch(error) {
            console.log('close', error.code);
            console.log(error.message);
          }
        }
      }, 4000);
      
    }
  },

  async connectDevice({ state, dispatch, getters }) {
    getters.clearConfig;
    const devices = await navigator.usb.getDevices({ filters: [] });
    if (devices.length > 0) {
      state.posPrinter = devices[0];
      getters.fetchConfiguration;
    } else {
      try {
        const selectedDevice = await navigator.usb.requestDevice({ filters: [] })
        state.posPrinter = selectedDevice;
        // find out what configuration and interface is correct
        getters.fetchConfiguration;
      } catch(error) {
        alert(error.message);
        console.log('request', error.code);
        console.log(error.message);
        getters.clearConfig;
      }
    }
  },

  async createPdf({ rootState }, { element, reportType, startTime }) {
    const pixelToMM = 0.264583;
    const pdf = new jsPDF('p', 'mm', 'a4');
    const maxWidth = pdf.internal.pageSize.width;
    const maxHeight = pdf.internal.pageSize.height;
    const station = rootState.auth.user.station.name;
    const location = rootState.auth.user.location.name;
    const shift = rootState.auth.user.shift ? rootState.auth.user.shift.name : '';
    let name = '';
    let message = '';
    if (reportType == 'shift') {
      name = `${dayjs(startTime).format('DD-MM-YYYY-HH-mm')
      }--${station}--${location}--Shift-${shift}.pdf`;
      message = `[ ${station}/${location} ] ${
        dayjs(startTime).format('DD-MM-YYYY HH:mm')
      } End Shift ${shift} Report`;
    } else if (reportType == 'workDay') {
      name = `${dayjs(startTime).format('DD-MM-YYYY-HH-mm')
      }--Day-Report--${location}.pdf`;
      message = `[ ${location} ] ${
        dayjs(startTime).format('DD-MM-YYYY HH:mm')
      } End Day Report`;
    } else if (reportType === 'monthReport') {
      name = `${dayjs(startTime).format('MM-YYYY')
      }--Month-Report--${location}.pdf`;
      message = `[ ${location} ] ${
        dayjs(startTime).format('MM-YYYY')
      } Month Report`;
    }
    return html2canvas(element).then((canvas) => {
      const img = canvas.toDataURL('image/jpeg');
      let width = canvas.width * pixelToMM;
      let height = canvas.height * pixelToMM;
      if (width > maxWidth) {
        width = maxWidth;
        height = Math.round(height / width * maxWidth);
      }
      pdf.addImage(img, 'JPEG', 0, 0, width, height, 'image', 'FAST');
      const pages = Math.ceil(height / maxHeight) - 1;
      for (let i = 1; i <= pages; i++) {
        const position = 0 - maxHeight * i;
        pdf.addPage();
        pdf.addImage(img, 'JPEG', 0, position, width, height, 'image', 'FAST');
      }
      const blob = pdf.output('blob');
      const file = new File([blob], name, {
        type: 'application/pdf',
        lastModified: Date.now(),
      });
      return {
        pdf, file, name, message,
      };
    });
  },

};

export default {
  state: localState,
  getters: localGetters,
  actions,
};
